import { GetProductionChartDataType } from '@vae/server/src/Charts/ProductionChart/getProductionChartData'
import dayjs from 'dayjs'
import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import useUser from '../../../../../contexts/hooks/useUser'
import { ObjectContext } from '../../../../../contexts/objectContext/ObjectContext'
import BaseChartScroller from '../../../components/BaseChartScroller'
import { ProductionChartTimeHook } from '../hooks/useProductionChartTime'
import ProductionSummary from './ProductionSummary'

interface ProductionChartScrollerProps {
	time: ProductionChartTimeHook
	chartData: GetProductionChartDataType | undefined | null
	isLoading: boolean
}

const ProductionChartScroller: React.FC<ProductionChartScrollerProps> = ({
	time,
	chartData,
	isLoading,
}) => {
	const { user } = useUser()

	const { t } = useTranslation('pages_electricity')

	const { synerallProductionId, productionGsrn } = useContext(ObjectContext)

	// Find where production

	const panelLinked = Boolean(user?.panelLinked)
	const hasProduction = Boolean(synerallProductionId) || Boolean(productionGsrn)

	const canGoNext = useMemo(() => {
		const diffToCurrentTime = time.endTime.diff(dayjs(), 'minute', true)

		return diffToCurrentTime < 0
	}, [time])

	return (
		<BaseChartScroller
			time={time}
			tooltipLoading={isLoading}
			unit={t('productionLabel')}
			value={chartData?.totalProduction ?? 0}
			canGoNext={canGoNext}
		>
			<ProductionSummary
				panelLinked={panelLinked}
				hasProduction={hasProduction}
				chartData={chartData}
			/>
		</BaseChartScroller>
	)
}

export default ProductionChartScroller
